// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2RfsN","alert":"SettungsInbox_alert__1utzs"};